/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiCaseStepEstimationType {
    None = 'NONE',
    Date = 'DATE',
    Timestamp = 'TIMESTAMP'
}

export function ApiCaseStepEstimationTypeFromJSON(json: any): ApiCaseStepEstimationType {
    return ApiCaseStepEstimationTypeFromJSONTyped(json, false);
}

export function ApiCaseStepEstimationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCaseStepEstimationType {
    return json as ApiCaseStepEstimationType;
}

export function ApiCaseStepEstimationTypeToJSON(value?: ApiCaseStepEstimationType | null): any {
    return value as any;
}

